import type { QueueWait } from './types'

type QueueSemaphore = 'green' | 'yellow' | 'red' | null

export function queueSemaphore(wait: QueueWait | undefined, yellowMinutes: number | undefined, redMinutes: number | undefined, now: number): QueueSemaphore {
  if (!wait || wait.total <= 0 || !wait.nextPrevision || yellowMinutes == null || redMinutes == null || redMinutes <= yellowMinutes) {return null}
  const next = Date.parse(wait.nextPrevision)
  if (!Number.isFinite(next)) {return null}
  if (next >= now - yellowMinutes * 60_000) {return 'green'}
  if (next >= now - redMinutes * 60_000) {return 'yellow'}
  return 'red'
}

export function queueSemaphoreOrder(wait: QueueWait | undefined, yellowMinutes: number | undefined, redMinutes: number | undefined, now: number): number {
  const color = queueSemaphore(wait, yellowMinutes, redMinutes, now)
  if (color === 'red') {return 0}
  if (color === 'yellow') {return 1}
  if (color === 'green') {return 2}
  if (wait?.total === 0) {return 3}
  return 4
}
